<script>
export default {
    setup() {
        const auth = useAuthStore();
        const notification = useNotificationStore();
        const pusher = usePusherStore();
        const { t } = useI18n();
        return { auth, notification, pusher, t };
    },
    data() {
        return {
            onLine: navigator.onLine,
            showBackOnline: false,
            needChangePassword: false
        }
    },
    computed: {
        ...mapGetters(useAuthStore, ['hasSession']),
        ...mapGetters(useResponseStore, ['htmlError', 'errors']),
    },
    async created() {
        if (!this.hasSession) {
            await this.loadSession();
        }
        if (!this.hasSession) {
            this.$router.replace('/auths/login');
        }
    },
    methods: {
        ...mapActions(useAuthStore, ['loadSession', 'getMe', 'getPermission']),
        popupNotif(eventName, data) {
            if (data.title) {
                this.notification.fetchAll({ isRead: 0 }).catch(err => { });
                this.$swal({
                    icon: 'success',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    title: data.title,
                    html: data.message,
                    timer: 5000,
                    toast: true,
                }).then(async () => {
                    await this.getPermission().catch(err => { });
                    await this.getMe().catch(err => { });
                    await this.loadSession();

                    if ("Notification" in window) {
                        Notification.requestPermission().then((permission) => {
                            if (permission === "granted") {
                                if ("serviceWorker" in navigator) {
                                    // Use service worker for mobile notifications
                                    navigator.serviceWorker.ready.then((registration) => {
                                        registration.showNotification(data.title, {
                                            body: data.message,
                                            icon: "/favicon.ico",
                                        });
                                    });
                                } else {
                                    // Use regular Notification for desktop
                                    const notification = new Notification(data.title, {
                                        body: data.message,
                                        icon: "/favicon.ico",
                                    });

                                    // You can handle click events on the notification
                                    notification.onclick = () => {
                                        window.location = window.location.origin + data.link;
                                    };
                                }
                            }
                        });
                    } else {
                        console.error("Notification API not supported in this browser");
                    }
                });


            }
        },
        updateOnlineStatus(e) {
            const { type } = e
            this.onLine = type === 'online';
        },
        updatePassword() {
            const modal = UIKit.modal('#modal-change-password');
            if (modal) {
                modal.show();
            } else {
                this.$swal({
                    icon: 'warning',
                    showConfirmButton: false,
                    text: this.t('Modal element not found or UIkit has not loaded.'),
                    timer: 1500,
                });
            }
        }
    },
    mounted() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/sw.js')
                .then((registration) => {
                    console.log('Service Worker registered with scope:', registration.scope);
                })
                .catch((error) => {
                    console.error('Service Worker registration failed:', error);
                });
        }

        if (!this.auth) return;
        if (!this.auth.token) return;
        if (!this.auth.user) return;

        if ("Notification" in window) {
            Notification.requestPermission().then((permission) => {
                console.info('Notification Granted')
            });
        }

        window.addEventListener('online', this.updateOnlineStatus)
        window.addEventListener('offline', this.updateOnlineStatus)
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus)
        window.removeEventListener('offline', this.updateOnlineStatus)
    },
    watch: {
        auth: {
            deep: true,
            handler(payload) {
                if (payload) {
                    if (payload.user && payload.token) {
                        this.pusher.registerConnection();
                        const channel = this.pusher.registerChannel('private-App.' + payload.user.id);
                        if (channel) {
                            channel.bind_global(this.popupNotif);
                        }
                    }

                    const userNeedChangePassword = payload?.user?.needChangePassword && payload?.user?.roleLevel > 0;
                    const isRequiredChangePassword = payload?.user?.passwordChangeRequired;

                    if (userNeedChangePassword && isRequiredChangePassword) {
                        this.$router.replace('/force-password-change');
                    } else if (userNeedChangePassword) {
                        this.needChangePassword = true;
                    }
                }
            }
        },
        onLine(v) {
            if (v) {
                this.showBackOnline = true
                setTimeout(() => {
                    this.showBackOnline = false
                }, 1000)
            }
        }
    },
}
</script>
<template>
    <div v-if="onLine">
        <DashboardsHeader />
        <DashboardsNavigation />
        <div class="container show margin-bottom-large" id="container">
            <div v-if="needChangePassword" class="uk-padding-small  uk-margin-small-top uk-margin-small-bottom">
                <AlertWarning variant="danger" :gradient="true" :pill="true" :dense="true" :shadow="true"
                    :divider="true" :closable="false"
                    title="Account security: You haven't changed your password for 3 months (90 days). Please update it now.">
                    <template #actions>
                        <button class="uk-button uk-button-small uk-button-warning" @click="updatePassword">
                            {{ t('Update Password') }}
                        </button>
                    </template>
                </AlertWarning>
            </div>
            <RouterView :key="$route.fullPath"/>
            <div style="height: 60px;" class="uk-hidden@m"></div>
        </div>
        <DashboardsFooter />
    </div>
    <Offline v-else />
</template>
